module.exports = __webpack_public_path__ + "static/media/P5JS.7d86c020.png";